import React from 'react';
import data from '../../data/home/header-slider';

function Header() {
    return (
        <header className="tc-header-style1">
            <div className="swiper-wrapper">
                {data.map((item, i) => (
                    <div key={i} className="swiper-slide">
                        <div className="slider-card">
                            <div className="img">
                                <img src={item.img} alt="" className="img-cover"/>
                            </div>
                            <div className="info">
                                <div className="container">
                                    <div className="text-start">
                                        <h1 data-swiper-parallax="-2000" style={{ fontSize: '4rem', marginBottom: '20px' }}>
                                            CRAFTING VISIONS IN METAL
                                        </h1>
                                        <h5 className="fw-400" style={{ fontSize: '1.5rem', marginBottom: '40px' }}>
                                            Precision Fabrication for Architects, Designers, & Custom Builders
                                        </h5>
                                        <div>
                                            <a
                                                href="/contact"
                                                className="butn border rounded-pill hover-bg-black bg-orange1 text-white align-items-center"
                                                aria-label="Get a free quote for metal fabrication services"
                                            >
                                              <span>
                                                Get a Quote
                                                <i className="small ms-1 ti-arrow-top-right"></i>
                                              </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </header>
    );
}

export default Header;
